import React, {Component} from 'react';
import {Button, DialogTitle, Flex} from '@priority-software/priority-style-react';
import {companiesFromData, saveSelected} from '../actions/multiCompanies';
import {DialogSelect} from './MultiCompaniesSelect';
import {DialogModal} from '../../../_shared/componnets/Dialog/Dialog';
import texts from '../texts';

export class MultiCompanyDialog extends Component<any, any> {
    state = {
        store: null,
        isOpen: false
    };

    showDialog = data => {
        const store = companiesFromData(data);
        this.setState({store: store, isOpen: true});
    };

    onCloseHandler = () => {
        this.setState({isOpen: false});
    };

    renderDialogContent = () => {
        return <DialogSelect companiesStore={this.state.store} />;
    };

    onConfirm = () => {
        saveSelected(this.state.store);
        this.setState({isOpen: false});
    };

    renderTitle = () => {
        return <DialogTitle title={texts.multiSelectTitle} textColor={'primary-500'} />;
    };

    renderFooter = () => {
        return (
            <Flex justifyContent="flex-end">
                <Button onClick={this.onConfirm}>{texts.ok}</Button>
            </Flex>
        );
    };

    render() {
        const {isOpen} = this.state;
        if (isOpen) {
            return (
                <DialogModal
                    isDialogOpen={isOpen}
                    content={this.renderDialogContent()}
                    onClose={this.onCloseHandler}
                    title={this.renderTitle()}
                    footer={this.renderFooter()}
                    width={718}
                    size={'large'}
                />
            );
        } else {
            return null;
        }
    }
}
